import _ from 'lodash';
import { JwtTokens, StorageKey } from './jwt-commons';

export class JwtTokenRepository {
    /**
     * 싱글톤 인스턴스
     */
    private static instance: JwtTokenRepository | null = null;

    private tokenStore: TokenStore | null = null;

    /**
     * 기본 생성자
     */
    private constructor() {
        this.tokenStore = LocalStorageTokenStore.getInstance();
    }

    /**
     * 싱글톤 인스턴스 획득
     * @returns
     */
    public static getInstance(): JwtTokenRepository {
        if (!this.instance) {
            this.instance = new JwtTokenRepository();
        }
        return this.instance;
    }

    /**
     * 기존 Access Token/Refresh Token 삭제
     */
    public clearTokens(): void {
        this.tokenStore?.clearTokens();
    }

    /**
     * 신규 발급 토큰(AT/RT) 저장
     * @param tokens
     */
    public saveTokens(tokens: JwtTokens): void {
        this.tokenStore?.saveTokens(tokens);
    }

    /**
     * Access Token 획득
     */
    public getAccessToken(): string | null | undefined {
        return this.tokenStore?.getAccessToken();
    }

    /**
     * Refresh Token 획득
     */
    public getRefreshToken(): string | null | undefined {
        return this.tokenStore?.getRefreshToken();
    }
}

/**
 * 토큰 저장/관리 인터페이스
 */
interface TokenStore {
    //기존 Access Token/Refresh Token 삭제
    clearTokens(): void;

    //신규 발급 토큰(AT/RT) 저장
    saveTokens(tokens: JwtTokens): void;

    //Access Token 획득
    getAccessToken(): string | null;

    //Refresh Token 획득
    getRefreshToken(): string | null;
}

/**
 * 로컬스토리지 토큰 저장/관리
 */
class LocalStorageTokenStore implements TokenStore {
    //싱글톤 인스턴스
    private static instance: LocalStorageTokenStore | null = null;

    //기본 생성자
    private constructor() {}

    //싱글톤 인스턴스 획득
    public static getInstance(): LocalStorageTokenStore {
        if (!this.instance) {
            this.instance = new LocalStorageTokenStore();
        }
        return this.instance;
    }

    //기존 Access Token/Refresh Token 삭제
    public clearTokens(): void {
        console.log('jwt-token-repository > clearTokens(기존 저장 토큰(AT/RT) 삭제)');
        localStorage.removeItem(StorageKey.AccessToken);
        localStorage.removeItem(StorageKey.RefreshToken);
    }

    //신규 발급 토큰(AT/RT) 저장
    public saveTokens(tokens: JwtTokens): void {
        console.log(
            'jwt-token-repository > saveTokens(신규 발급 토큰(AT/RT) 저장) - tokens',
            tokens,
        );

        //Access Token 저장
        localStorage.setItem(
            StorageKey.AccessToken,
            _.isUndefined(tokens.accessToken) ? '' : tokens.accessToken,
        );

        //Refresh Token 저장
        localStorage.setItem(
            StorageKey.RefreshToken,
            _.isUndefined(tokens.refreshToken) ? '' : tokens.refreshToken,
        );
    }

    //Access Token 획득
    public getAccessToken(): string | null {
        return localStorage.getItem(StorageKey.AccessToken);
    }

    //Refresh Token 획득
    public getRefreshToken(): string | null {
        return localStorage.getItem(StorageKey.RefreshToken);
    }
}
